import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import banner from "../../../images/banner-bg.png"
import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import "./SingleCourse.scss"
import AOS from "aos";

import { AccountCircle, AccessTime, PlayLesson, PeopleAlt, Language, SettingsAccessibility, Quiz, VerifiedUser, CastForEducation, Check } from '@mui/icons-material';
const SingleWebDesign = () => {

    useEffect(() => {
        AOS.init({
            offset: 100,
            duration: 1000,
            easing: "ease"
        });
    });
    return (
        <>
            <Header />
            <div className="single-course-hero">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6}>
                            <div data-aos="fade-right" className="course-hero-left" data-aos="fade-left">
                                <h2>ওয়েব ডিজাইন </h2>
                                <ul className="list">
                                    <li> কোর্সের মেয়াদ :   <span> ৩ মাস বা তদুর্ধ </span></li>
                                    <li> কোর্স ফি  :   <span>৬ ০০০ টাকা</span></li>
                                    <li>ক্লাসের সময় :   <span>সপ্তাহে ৬ দিন </span></li>
                                    <li> ক্লাস শুরুর তারিখ :    <span> ০১ জানুয়ারি ২০২২</span></li>
                                </ul>
                                <p>অভিজ্ঞতা অর্জন হয় দক্ষতা বৃদ্ধির মাধ্যমে। আর দক্ষতাই পারে সাফল্যের শিখরে পৌঁছে দিতে। তাই সময় নষ্ট না করি, দক্ষতা বৃদ্ধি করি।</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="course-hero-right" data-aos="fade-right">
                                <img src={banner} alt="Image  not found " />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="course-details">
                <Container>
                    <Row>
                        <Col lg={8} md={6}>
                            <div className="course-details-left" >
                                <div className="course-img" data-aos="zoom-out-up">
                                    <img src="https://edemy-react.envytheme.com/images/courses/courses2.jpg" alt="Image not  found " />
                                </div>

                                <div className="courses-details-desc-style-two" data-aos="zoom-out-up">
                                    <h3>কোর্স সম্পর্কে</h3>
                                    <p>ওয়েব ডিজাইন মানে ব্যবহারকারী-বান্ধব কাঠামো এবং একটি নান্দনিক পদ্ধতির সাথে ওয়েবসাইট তৈরি করা। একজন ওয়েব ডিজাইনার সর্বদা একটি ওয়েবসাইটের লেআউট, রঙের ধরন এবং অনন্য ডিজাইন সম্পর্কে চিন্তা করেন। কিন্তু তাদের কাজ শুধু সেখানেই শেষ নয়। তারা একটি ব্যবহারকারী-বান্ধব নেভিগেশন সিস্টেম তৈরি করতে কঠোর পরিশ্রম করে। তাদের ওয়েবসাইটগুলিকে র‌্যাঙ্ক করতে হবে এবং এর জন্য তাদের কিছু এসইও করতে হয়। সংক্ষেপে ওয়েব ডিজাইনারকে ফ্রন্ট-এন্ড ডিজাইনার বা অভিজ্ঞ ডিজাইনার হিসাবে চিহ্নিত করা যেতে পারে। একজন ওয়েব ডিজাইনারকে এমন ইন্টারফেস ডিজাইন করতে হয় যা ভিজিটরদের জন্য আরামদায়ক, আকর্ষণীয় এবং বন্ধুত্বপূর্ণ হবে। তবে এটি রেসপন্সিভ হতে হবে যাতে ব্যবহারকারীরা তাদের পছন্দ অনুযায়ী বিভিন্ন ডিভাইসে এটি ব্যবহার করতে পারে। এডভান্সড আইটি ইনস্টিটিউটে, আমরা আমাদের ছাত্রদেরকে আধুনিক এবং সবচেয়ে আপ-টু-ডেট কৌশল শেখাবো যা সফল ওয়েব ডিজাইনার হতে তাদের সহায়তা করবে।</p>


                                    <div className="courses-curriculum" data-aos="zoom-out-up">
                                        <h3>কোর্স মডিউল</h3>
                                        <ul>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 01 : </span>
                                                HTML5

                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 02 : </span>
                                                CSS3

                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 03 : </span>
                                                Design To HTML
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 04 : </span>
                                                CSS3 Animation Effect
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 05 : </span>
                                                Git & Github
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 06 : </span>
                                                JavaScript
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 07 : </span>
                                                SASS
                                            </li>
                                            <li>
                                                <CastForEducation />
                                                <span>Module 08 : </span>
                                                jQuery
                                            </li>

                                        </ul>

                                    </div>
                                    <h3>পূর্বশর্ত</h3>
                                    <div className="why-you-learn" data-aos="zoom-out-up">
                                        <ul>
                                            <li><span><Check /></span> বেসিক কম্পিউটার কোর্স করা থাকতে হবে</li>
                                        </ul>
                                    </div>

                                </div>

                            </div>
                        </Col>
                        <Col lg={4} md={6}>
                            <div className="courses-sidebar-information" data-aos="zoom-out-up">
                                <ul className="info">
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>  <AccountCircle />  Instructor </span>
                                            Sanjoy Banik
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span> <AccessTime />  Duration</span> 3 Months
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><PlayLesson /> Lessons</span>60
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><SettingsAccessibility /> Access</span>Lifetime
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><Quiz /> Quizzes</span>YES
                                        </div>
                                    </li>
                                    <li>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><VerifiedUser /> Certificate</span>YES
                                        </div>
                                    </li>
                                </ul>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


            <Footer />




        </>
    );
};

export default SingleWebDesign;